import React, { useEffect, useState } from 'react';
import { ResponsiveContainer, ComposedChart, Bar, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend } from 'recharts';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { qualityNcrAPI } from '@/lib/api';

const Toggle = ({ options, value, onChange, testid }) => (
  <div className="flex rounded-md border overflow-hidden" data-testid={testid}>
    {options.map(([v, l]) => (
      <button key={v} onClick={() => onChange(v)} className={`px-2.5 py-1 text-xs ${value === v ? 'bg-teal-600 text-white' : 'hover:bg-muted'}`} data-testid={`${testid}-${v}`}>{l}</button>
    ))}
  </div>
);

const short = (s) => (s.length > 18 ? `${s.slice(0, 17)}…` : s);

export const ParetoCard = ({ dateFrom, dateTo }) => {
  const [source, setSource] = useState('customer');
  const [group, setGroup] = useState('reason');
  const [data, setData] = useState(null);
  useEffect(() => {
    qualityNcrAPI.pareto({ date_from: dateFrom, date_to: dateTo, source, group }).then((r) => setData(r.data)).catch(() => setData(null));
  }, [dateFrom, dateTo, source, group]);
  const rows = (data?.rows || []).slice(0, 12);
  return (
    <Card className="shadow-none" data-testid="ppm-pareto-card">
      <CardHeader className="pb-1 flex-row flex-wrap items-center gap-3 space-y-0">
        <CardTitle className="text-sm mr-auto">Pareto — {source === 'customer' ? 'customer complaints' : 'internal rejections'} by {group}
          <span className="text-xs font-normal text-muted-foreground"> ({data?.total || 0} records)</span></CardTitle>
        <Toggle testid="pareto-source" value={source} onChange={setSource} options={[['customer', 'Customer'], ['internal', 'Internal']]} />
        <Toggle testid="pareto-group" value={group} onChange={setGroup} options={[['reason', 'Reason'], ['customer', 'Customer'], ['part', 'Part']]} />
      </CardHeader>
      <CardContent className="h-80">
        {rows.length === 0 ? <p className="text-sm text-muted-foreground text-center py-12" data-testid="pareto-empty">No records in this period</p> : (
          <ResponsiveContainer width="100%" height="100%">
            <ComposedChart data={rows} margin={{ bottom: 40 }}>
              <CartesianGrid strokeDasharray="3 3" vertical={false} />
              <XAxis dataKey="label" tickFormatter={short} tick={{ fontSize: 10 }} angle={-25} textAnchor="end" interval={0} />
              <YAxis yAxisId="n" tick={{ fontSize: 11 }} allowDecimals={false} />
              <YAxis yAxisId="p" orientation="right" domain={[0, 100]} tickFormatter={(v) => `${v}%`} tick={{ fontSize: 11 }} />
              <Tooltip formatter={(v, n) => (n === 'Cumulative %' ? `${v}%` : v)} />
              <Legend verticalAlign="top" wrapperStyle={{ fontSize: 11 }} />
              <Bar yAxisId="n" dataKey="count" name="Records" fill="#f87171" />
              <Line yAxisId="p" dataKey="cumulative_pct" name="Cumulative %" stroke="#0f766e" strokeWidth={2} />
            </ComposedChart>
          </ResponsiveContainer>
        )}
      </CardContent>
    </Card>
  );
};
